import { render } from "./BoatDetailsPage.vue?vue&type=template&id=8c9caf4e&scoped=true"
import script from "./BoatDetailsPage.vue?vue&type=script&lang=js"
export * from "./BoatDetailsPage.vue?vue&type=script&lang=js"

import "./BoatDetailsPage.vue?vue&type=style&index=0&id=8c9caf4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c9caf4e"]])

export default __exports__